import React, { Component } from "react";
import { debounce } from "lodash";

import api from "services/api";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as DocumentsActions,
  Selectors as DocumentsSelectors,
} from "store/ducks/documents";

import { Access } from "common";
import { Form } from "components";

class Filters extends Component {
  state = {
    filter: this.props.filter,
    status: [
      { value: "", label: "Todos" },
      { value: "approved", label: "Aprovado" },
      { value: "rejected", label: "Reprovado" },
      { value: "pendent", label: "Pendente" },
      { value: "cancelled", label: "Cancelado" },
    ],
  };

  constructor(props) {
    super(props);

    this.handleSearchStores = debounce(this.loadStores, 300);
  }

  componentDidMount() {
    const { /* getDocumentStoresRequest, */getStatesDocumentRequest } = this.props;

    // getDocumentStoresRequest();
    this.loadStores()
    getStatesDocumentRequest();
  }

  componentDidUpdate(oldProps) {
    const { filter } = this.props;

    if (oldProps.filter !== filter) {
      this.setState({ filter });
    }
  }

  loadStores = async (query = null) => {
    try {
      const response = await api.get("/store/v2/places", {
        params: {
          presential_docs: true,
          search: query,
          per: 30,
        },
      });

      const { data } = response.data;

      this.setState({ stores: data.map(store => ({ value: store.id, label: store.attributes.name })) })
    } catch (err) {}
  };

  handleFindStore = (query) => {
    this.handleSearchStores(query);
  };

  render() {
    const { filter, status, stores } = this.state;
    const { onChange, onChangeInput, onClean, states } = this.props;

    return (
      <Form>
        <div className="row">
          <Form.Field className="col-md-3">
            <Form.Label>Lojas</Form.Label>
            <Form.Select
              placeholder="Lojas"
              value={filter.store}
              options={stores}
              onChange={(value) => onChange("store", value)}
              onInputChange={this.handleFindStore}
              noOptionsMessage={() => "Loja não encontrada"}
              cleaneable
              isDisabled={!!Access.lockedStore()}
            />
          </Form.Field>

          <Form.Field className="col-md-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              placeholder="Status"
              value={filter.status}
              options={status}
              onChange={(value) => onChange("status", value)}
            />
          </Form.Field>

          <Form.Field className="col-md-3">
            <Form.Label>Estado</Form.Label>
            <Form.Select
              placeholder="Estado"
              value={filter.state}
              options={states.data}
              onChange={(value) => onChange("state", value)}
              noOptionsMessage={() => "Sem UF's"}
            />
          </Form.Field>

          <Form.Field className="col-md-3">
            <Form.Label>Profissional</Form.Label>
            <Form.Input
              name="search"
              placeholder=""
              value={filter.search.value}
              onChange={(e) => onChangeInput(e.target.value)}
            />
          </Form.Field>
        </div>

        <div className="row">
          <Form.Field className="col-md-3">
            <Form.Label>Período, de</Form.Label>
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={filter.start_date}
              onChange={(value) => onChange("start_date", value)}
            />
            <div className="icon-input">
              <span className="glyph glyph-calendar" />
            </div>
          </Form.Field>

          <Form.Field className="col-md-3">
            <Form.Label>Período, até</Form.Label>
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={filter.end_date}
              minDate={filter.start_date}
              disabled={filter.start_date === null}
              onChange={(value) => onChange("end_date", value)}
            />
            <div className="icon-input">
              <span className="glyph glyph-calendar" />
            </div>
          </Form.Field>

          <Form.Field className="col-md-3">
            <Form.Button className="button-clean-filter" onClick={onClean}>
              Resetar Filtro
            </Form.Button>
          </Form.Field>
        </div>
      </Form>
    );
  }
}

const mapState = (state) => ({
  stores: {
    ...state.documents.stores,
    data: DocumentsSelectors.stores(state.documents.stores.data),
  },

  states: {
    ...state.documents.states,
    data: DocumentsSelectors.states(state.documents.states.data),
  },
});

const mapActions = (dispatch) => bindActionCreators(DocumentsActions, dispatch);

export default connect(mapState, mapActions)(Filters);
